import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { type MaybeRefOrGetter, unref } from 'vue';

type RegionTagSorting = '-popularity' | '-excursions_count' | '-tours_count';

const DEFAULT_PAGE_SIZE = 300;

interface Params {
  slug: MaybeRefOrGetter<string>;
  pageSize?: MaybeRefOrGetter<number>;
  sorting?: MaybeRefOrGetter<RegionTagSorting>;
  enabled?: MaybeRefOrGetter<boolean>;
}

const setParams = (params: Params): Required<Params> => {
  return {
    slug: params.slug,
    pageSize: params?.pageSize || computed(() => DEFAULT_PAGE_SIZE),
    sorting: params?.sorting || computed(() => '-popularity'),
    enabled: params?.enabled !== undefined ? params?.enabled : computed(() => true),
  };
};
export const useRegionTag = (params: Params) => {
  const { slug, pageSize, enabled, sorting } = setParams(params);
  const { getRegionTags } = useExperienceApi();

  const { data: regionTags } = useQuery({
    queryKey: ['regionTag', slug, pageSize, sorting],
    queryFn: () => {
      return getRegionTags({
        query: {
          region__slug: unref(slug) as string,
          page_size: unref(pageSize) as number,
          sorting: unref(sorting) as RegionTagSorting,
        },
      });
    },
    enabled: computed(() => !!unref(enabled)),
    placeholderData: (prev) => prev,
    select: (response) => response.data?.results,
    retry: false,
  });

  return {
    regionTags,
  };
};
